import * as Diagram from "../../../../components/diagram";

export const VillageCaseRegularRecordCompletionRate = {
  label: "18鄉鎮立案定期訪視暨紀錄登錄完成率",
  key: "VillageCaseRegularRecordCompletionRate",
  path: "BoneMuscleCare/VillageCaseRegularRecordCompletionRate",
  api: "TSC_V_CaseRegularRecordCompletionRate",
  render: (options) => (
    <Diagram.BoneMuscleCare.VillageCaseRegularRecordCompletionRate
      {...options}
    />
  ),
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  filterColumns: [{ key: "篩檢日期", type: "date" }],
  dateRangeColumns: [{ label: "篩檢日期", key: "篩檢日期" }],
  columns: [
    {
      key: "應訪視追蹤數",
      field: "應訪視追蹤數",
      header: "應訪視追蹤數",
      countKey: "應訪視追蹤數",
    },
    {
      key: "實際完成數",
      field: "實際完成數",
      header: "實際完成數",
      countKey: "實際完成數",
    },
    {
      key: "執行率",
      field: "執行率",
      header: "執行率",
    },
  ],
  headColumns: [
    [{ headerName: "應訪視追蹤數" }],
    [{ headerName: "實際完成數" }],
  ],
};
